import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim(), base: window.location.origin });
    } catch { /* never reveal */ }
    finally { setLoading(false); setSent(true); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background grain px-4">
      <div className="w-full max-w-sm border-2 border-foreground bg-card p-8">
        <Link to="/login" className="inline-flex items-center gap-1 text-xs uppercase tracking-wider text-muted-foreground hover:text-foreground mb-6" data-testid="back-to-login">
          <ArrowLeft size={14} /> Back to login
        </Link>
        <h1 className="font-display text-4xl uppercase leading-none mb-2">Forgot<br />password?</h1>
        {sent ? (
          <div data-testid="forgot-sent" className="mt-4 border-2 border-[hsl(var(--pitch-green))]/50 bg-[hsl(var(--pitch-green))]/5 p-4 text-sm">
            If an account exists for <span className="font-bold">{email}</span>, we've sent a reset link. Check your inbox (and spam) — the link is valid for 1 hour.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-3">
            <p className="text-sm text-muted-foreground">Enter your email and we'll send you a link to set a new password.</p>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com" data-testid="forgot-email" className="rounded-none ps-9" />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full rounded-none bg-primary text-primary-foreground uppercase font-bold">
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
